module.exports = __webpack_public_path__ + "static/media/56_tn.f88b28a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/56_tn.jpg
// module id = 364
// module chunks = 0